export default "__VITE_ASSET__BcExJqAr__"